/// <amd-module name="Artifacts/Upack/components/UpackPackageAttributes" />
import {
  IProjectAttribute,
  PackageDevelopment,
} from "Artifacts/Package/components/package-details-common/PackageDevelopment";
import { PackageProvenance } from "Artifacts/Package/components/package-details-common/PackageProvenance";
import { PackageStats } from "Artifacts/Package/components/package-details-common/PackageStats";
import { PackageTags } from "Artifacts/Package/components/package-details-common/PackageTags";
import * as PackageRes from "Artifacts/Package/Resources";
import { IProtocolOverviewProps } from "Artifacts/Root/protocols/types";
import * as React from "react";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";
import { useComponentContext } from "VSS/Platform/Layout";

const UpackAttributes: React.FC<IProtocolOverviewProps> = ({ feed, pkg, version }) => {
  const { pageContext } = useComponentContext();
  const isProvenanceEnabled = isFeatureFlagEnabled(
    pageContext,
    "Packaging.Feed.WebAccess.Provenance",
    false,
  );
  const isMetricsEnabled = isFeatureFlagEnabled(
    pageContext,
    "Packaging.Feed.WebAccess.Metrics",
    false,
  );

  const projectAttributes: IProjectAttribute[] = [];

  return (
    <section className="package-overview-attributes" aria-label={PackageRes.PackageMetadata}>
      <div className="upack-overview-attributes-panel">
        <PackageProvenance
          pageContext={pageContext}
          feed={feed}
          packageId={pkg.id}
          versionId={version.id}
          publishDate={new Date(version.publishDate)}
          isProvenanceEnabled={isProvenanceEnabled}
          isProvenanceSupported={true}
        />
        <PackageDevelopment
          pageContext={pageContext}
          projectAttributes={projectAttributes}
          packageSummary={pkg}
          packageVersion={version}
          upstreamSources={feed.upstreamSources}
        />
        {isMetricsEnabled && (
          <PackageStats
            pageContext={pageContext}
            feed={feed}
            package={pkg}
            versionId={version.id}
            isMetricsEnabled={isMetricsEnabled}
          />
        )}
        {<PackageTags tags={version.tags} />}
        {<PackageTags title={PackageRes.PackageDetails_VersionsTable_Views} tags={version.views} />}
      </div>
    </section>
  );
};

export { UpackAttributes };
